<div class="container-fluid">
    <div class="row">
        <div class="col-12 header-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
            {{data.title}}
            <button type="button" class="close" (click)="close()"
                [ngStyle]="{'float': currLang == 'ar' ? 'left' : 'right'}">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="row" style='color:black'>
        <div class="col-12">
            <div class="message-wrapper">
                <div class="message-info">
                    <div class='row no-gutters detailsAndBtns-container '
                        [ngStyle]="{'flex-direction': currLang == 'en' ? 'row' : 'row-reverse'}">
                        <div class="col-10 details-container"
                            [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                            <div class='item-details col-2'>
                                <div class='head'>
                                    {{'messages.recipients' | translate}}
                                </div>
                                <div (click)='openMessageRecepients()' class='value recipients'>
                                    {{data.recepientsNo}} user
                                </div>
                            </div>
                            <div class='item-details col-2'>
                                <div class='head'>
                                    {{'messages.views' | translate}}
                                </div>
                                <div (click)="openMessageViewers()" class='value viewers'>
                                    {{data.views}}
                                </div>
                            </div>
                            <div class='item-details col-2'>
                                <div class='head'>
                                    {{'messages.time' | translate}}
                                </div>
                                <div class='value'>
                                    {{data.time}}
                                </div>
                            </div>
                            <div class='item-details col-2'>
                                <div class='head'>
                                    {{'messages.date' | translate}}
                                </div>
                                <div class='value'>
                                    {{data.date}}
                                </div>
                            </div>
                            <div class='item-details col-2'>
                                <div class='head'>
                                    {{'messages.via' | translate}}
                                </div>
                                <div class='value'>
                                    {{data.type|translate}}
                                </div>
                            </div>
                        </div>
                        <div class="col-2 delete-duplicate-container">
                            <svg class='icon-svg' (click)='duplicateMessage()' xmlns="http://www.w3.org/2000/svg"
                                width="16.328" height="17.812" viewBox="0 0 16.328 17.812">
                                <g id="portable-document-format" transform="translate(-1)">
                                    <path id="Path_5583" data-name="Path 5583"
                                        d="M16.761,18.843H7.855A1.858,1.858,0,0,1,6,16.988V5.855A1.858,1.858,0,0,1,7.855,4h8.906a1.858,1.858,0,0,1,1.855,1.855V16.988A1.858,1.858,0,0,1,16.761,18.843ZM7.855,4.742A1.115,1.115,0,0,0,6.742,5.855V16.988A1.115,1.115,0,0,0,7.855,18.1h8.906a1.115,1.115,0,0,0,1.113-1.113V5.855a1.115,1.115,0,0,0-1.113-1.113Z"
                                        transform="translate(-1.289 -1.031)" fill="#707070" />
                                    <path id="Path_5584" data-name="Path 5584"
                                        d="M3.6,15.586H2.855A1.858,1.858,0,0,1,1,13.73V1.855A1.858,1.858,0,0,1,2.855,0h8.906a1.858,1.858,0,0,1,1.855,1.855.371.371,0,1,1-.742,0A1.115,1.115,0,0,0,11.761.742H2.855A1.115,1.115,0,0,0,1.742,1.855V13.73a1.115,1.115,0,0,0,1.113,1.113H3.6a.371.371,0,1,1,0,.742Z"
                                        fill="#707070" />
                                    <path id="Path_5585" data-name="Path 5585"
                                        d="M16.308,16.742H10.371a.371.371,0,0,1,0-.742h5.937a.371.371,0,0,1,0,.742Z"
                                        transform="translate(-2.32 -4.125)" fill="#707070" />
                                    <path id="Path_5586" data-name="Path 5586"
                                        d="M16.308,20.742H10.371a.371.371,0,1,1,0-.742h5.937a.371.371,0,0,1,0,.742Z"
                                        transform="translate(-2.32 -5.157)" fill="#707070" />
                                    <path id="Path_5587" data-name="Path 5587"
                                        d="M16.308,12.742H10.371a.371.371,0,0,1,0-.742h5.937a.371.371,0,0,1,0,.742Z"
                                        transform="translate(-2.32 -3.094)" fill="#707070" />
                                    <path id="Path_5588" data-name="Path 5588"
                                        d="M16.308,8.742H10.371a.371.371,0,0,1,0-.742h5.937a.371.371,0,0,1,0,.742Z"
                                        transform="translate(-2.32 -2.063)" fill="#707070" />
                                </g>
                            </svg>
                            <!-- <svg (click)="deleteMessage()" class='icon-svg' xmlns="http://www.w3.org/2000/svg" width="14.467" height="17.812" viewBox="0 0 14.467 17.812">
                                <g id="bin_1_" data-name="bin (1)" transform="translate(0 0)">
                                <path id="Path_5376" data-name="Path 5376" d="M222.815,154.7a.417.417,0,0,0-.417.417V163a.417.417,0,1,0,.834,0V155.12A.417.417,0,0,0,222.815,154.7Zm0,0" transform="translate(-213.121 -148.25)" fill="#707070"/>
                                <path id="Path_5377" data-name="Path 5377" d="M104.815,154.7a.417.417,0,0,0-.417.417V163a.417.417,0,0,0,.834,0V155.12A.417.417,0,0,0,104.815,154.7Zm0,0" transform="translate(-100.043 -148.25)" fill="#707070"/>
                                <path id="Path_5378" data-name="Path 5378" d="M1.181,5.3V15.579a2.3,2.3,0,0,0,.612,1.587,2.054,2.054,0,0,0,1.49.644h7.892a2.054,2.054,0,0,0,1.49-.644,2.3,2.3,0,0,0,.612-1.587V5.3a1.593,1.593,0,0,0-.409-3.134H10.734V1.646A1.639,1.639,0,0,0,9.082,0h-3.7A1.639,1.639,0,0,0,3.726,1.646v.521H1.59A1.593,1.593,0,0,0,1.181,5.3Zm9.995,11.675H3.284a1.321,1.321,0,0,1-1.268-1.4V5.338H12.444V15.579a1.321,1.321,0,0,1-1.268,1.4ZM4.56,1.646A.8.8,0,0,1,5.378.833h3.7a.8.8,0,0,1,.818.813v.521H4.56ZM1.59,3H12.87a.751.751,0,1,1,0,1.5H1.59a.751.751,0,1,1,0-1.5Zm0,0" transform="translate(0.003 0.001)" fill="#707070"/>
                                <path id="Path_5379" data-name="Path 5379" d="M163.815,154.7a.417.417,0,0,0-.417.417V163a.417.417,0,1,0,.834,0V155.12A.417.417,0,0,0,163.815,154.7Zm0,0" transform="translate(-156.582 -148.25)" fill="#707070"/>
                                </g>
                            </svg> -->
                        </div>
                    </div>
                </div>
                <div class="message-content" style='height: 400px;'>
                    <app-view-message-content [messageContent]='safeHTML'></app-view-message-content>
                </div>
            </div>
        </div>
    </div>
</div>